import { memo } from 'react';

import { APPLE_APP_STORE_APP_URL, GOOGLE_PLAY_STORE_APP_URL } from '@/constants/storeUrls';

interface Props {
  store: 'apple' | 'google';
}

const MobileAppLink = ({ store }: Props) => {
  const attributes = () => {
    return store === 'apple'
      ? {
          href: APPLE_APP_STORE_APP_URL,
          src: '/images/app-store.png',
          alt: 'Download on the App Store'
        }
      : {
          href: GOOGLE_PLAY_STORE_APP_URL,
          src: '/images/play-store.png',
          alt: 'Get it on Google Play'
        };
  };

  const { alt, href, src } = attributes();

  return (
    <a href={href} target="_blank" rel="noopener noreferrer">
      <img src={src} alt={alt} width={200} />
    </a>
  );
};

export default memo(MobileAppLink);
